import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { TabView, TabPanel } from 'primereact/tabview';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { Paginator } from 'primereact/paginator';
import { Card } from 'primereact/card';
import { Chart } from 'primereact/chart';
import { locale } from 'primereact/api';
import * as jobConstants from "../../enums/jobs";
import labels_en from '../../localization/labels.json';
import labels_fr from '../../localization/labels_fr.json';
import moment from "moment";
import 'moment/locale/fr';
import {
  fetchUserFavouritesJobs,
} from '../favourites/favouritesSlice';
import {
  fetchJobs,
  fetchWatchListJobs,
  fetchErrorListJobs,
  fetchFavouriteFilterJobs,
  fetchJobsRecordsWedgit,
  fetchChildJobs,
  fetchJobDetails,
  fetchChannelFilter,
  setCurrentTabJobNo,
  setJobDeliveryChannelId,
  setJobListExist,
  setExpandedRows,
  addJobsInWatchList,
  setCheckedView,
  setSelectedChannel,
  setFromDate,
  setToDate,
  setDefaultFilterStatus,
  setPage,
  setSize,
  setBasicFirst,
  setBasicRows,
  setWatchListPage,
  setWatchListSize,
  setWatchListFirst,
  setWatchListRows,
  setErrorListPage,
  setErrorListSize,
  setErrorListFirst,
  setErrorListRows,
  setFavouriteListPage,
  setFavouriteListSize,
  setFavouriteListFirst,
  setFavouriteListRows,
  setAppLanguage,
  setDefaultLanguage,
} from './jobSlice';

export const JobView = () => {
  const [rowsPerPageOptions, setRowsPerPageOptions] = useState(jobConstants.ROWS_PER_PAGE_OPTIONS);
  const [dynamicTabs, setDynamicTabs] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const [toDateEnabled, setToDateEnabled] = useState(true);
  const jobState = useSelector((state) => state.job);
  const favouritesState = useSelector((state) => state.favourites);
  const {
    appLanguage,
    currentLanguage,
    userId,
    clientId,
    parentJobList,
    totalRecords,
    watchListTotalRecords,
    errorListTotalRecords,
    favouriteListTotalRecords,
    childJobList,
    jobDetails,
    currentTabJobNo,
    jobDeliveryChannelId,
    jobListExist,
    expandedRows,
    checkedView,
    currentTab,
    selectedChannel,
    defaultFilterStatus,
    fromDate,
    toDate,
    page,
    size,
    basicFirst,
    basicRows,
    watchListPage,
    watchListSize,
    watchListFirst,
    watchListRows,
    errorListPage,
    errorListSize,
    errorListFirst,
    errorListRows,
    favouriteListPage,
    favouriteListSize,
    favouriteListFirst,
    favouriteListRows,
    watchList,
    channelFilterList,
    deliveryChannelFilterList,
    jobRecordsWidgit
  } = jobState;
  const {
    userFavouritesJobList,
  } = favouritesState;

  let favJobNames = userFavouritesJobList?.map(fav => fav.jobName).join(',');

  const dispatch = useDispatch();
  let startDate;
  let endDate;

  useEffect(() => {
    dispatch(setDefaultLanguage(currentLanguage));
    if (currentLanguage === "EN") {
      moment.locale('en');
      locale('en');
      dispatch(setAppLanguage(labels_en));
    }
    if (currentLanguage === "FR") {
      moment.locale('fr');
      locale('fr');
      dispatch(setAppLanguage(labels_fr));
    }
  }, [currentLanguage]);

  useEffect(() => {
    if (defaultFilterStatus === true && currentTab !== jobConstants.TABS.WATCHLIST) {
      dispatch(setFromDate(new Date()));
      dispatch(setToDate(new Date()));
      startDate = new Date();
      endDate = new Date();
    } else if (defaultFilterStatus === true && currentTab === jobConstants.TABS.WATCHLIST) {
      dispatch(setFromDate(''));
      dispatch(setToDate(''));
      startDate = '';
      endDate = '';
    } else {
      dispatch(setFromDate(fromDate));
      dispatch(setToDate(toDate));
      startDate = fromDate;
      endDate = toDate;
    }
    let params = {
      clientId: clientId,
      userId: userId,
      type: currentTab,
      channelType: selectedChannel.deliveryChannelId,
      filterView: checkedView ? 1 : 0,
      fromDate: startDate ? moment(startDate).format("YYYY-MM-DD") : '',
      toDate: endDate ? moment(endDate).format("YYYY-MM-DD") : '',
      pageNum: page,
      pageSize: size
    };

    if (currentTab === jobConstants.TABS.LIVE) {
      let reportParams = {
        clientId: clientId,
        userId: userId,
        channelType: selectedChannel.deliveryChannelId,
        fromDate: startDate ? moment(startDate).format("YYYY-MM-DD") : '',
        toDate: endDate ? moment(endDate).format("YYYY-MM-DD") : '',
      };
      dispatch(fetchJobs(params));
      dispatch(fetchJobsRecordsWedgit(reportParams));
    } else if (currentTab === jobConstants.TABS.WATCHLIST) {
      params.pageNum = watchListPage;
      params.pageSize = watchListSize;
      params.jobNos = watchList.join();
      dispatch(fetchWatchListJobs(params));
    } else if (currentTab === jobConstants.TABS.ERROR) {
      params.pageNum = errorListPage;
      params.pageSize = errorListSize;
      dispatch(fetchErrorListJobs(params));
    } else {
      params.pageNum = favouriteListPage;
      params.pageSize = favouriteListSize;
      params.type = '';
      params.favJobs = favJobNames;
      dispatch(fetchFavouriteFilterJobs(params));
    }

  }, [dispatch, currentTab]);

  useEffect(() => {
    let param = {
      userId: userId,
      clientId: clientId,
    }
    dispatch(fetchChannelFilter(param));
    dispatch(fetchUserFavouritesJobs(param));
  }, []);

  // for circle bullet icon
  const bulletPoint = (rowData) => {
    return (
      <span className={'channel-circle ' + (rowData && rowData.slaStatus == 'amber' ? 'orange' : rowData && rowData.slaStatus == 'green' ? 'green' : 'red')}></span>
    );
  }

  const bulletPointChild = (rowData) => {
    return (
      <span className={'channel-circle ' + (rowData && rowData.slaStatuschild == 'amber' ? 'orange' : rowData && rowData.slaStatuschild == 'green' ? 'green' : 'red')}></span>
    );
  }

  // for channel file icon
  const channelFile = (rowData) => {
    const channelArray = rowData?.channelType?.split(',');
    return (
      channelArray?.length > 1 ? (
        <>
          <span className='channel-file recycle-icon'>
            <i className="ds-icon recycle-icon">
              <svg
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                x="0px" y="0px"
                viewBox="0 0 122.88 113.02"
                width="20.731"
                height="20"
                style={{ marginTop: "4px" }}
              >
                <g>
                  <path fill="#bfbfbf" d="M52.75,68.37c-7.63-6.3-17.48-9.41-29.54-9.35V44.02L0,67.81L23.21,90.9V77.76c9.07-0.05,15.78,2.48,20.14,7.61 c4.87,5.73,7.53,14.94,7.96,27.66l10.11-0.32l10.11,0.32c0.01-0.2,0.01-0.4,0.02-0.6h0.01v-0.35c0.53-12.23,3.17-21.12,7.92-26.71 c4.37-5.14,11.1-7.67,20.19-7.61V90.9l23.21-23.09L99.67,44.02v14.99c-11.32-0.06-20.69,2.66-28.11,8.19v-44h14.03L61.81,0 L38.72,23.21h14.03V68.37L52.75,68.37z" />
                </g>
              </svg>
              {/* <svg
                id="noun-recycle-409903"
                xmlns="http://www.w3.org/2000/svg"
                width="24.731"
                height="25"
                viewBox="0 0 24.731 25"
              >
                <g id="Group_32" data-name="Group 32" transform="translate(0)">
                  <g id="Group_31" data-name="Group 31">
                    <path
                      id="Path_23"
                      data-name="Path 23"
                      d="M7.527,25.487a12.012,12.012,0,0,0,16.982-.006l-.809-.809a10.868,10.868,0,0,1-15.364.006l.411-.411c.446-.446.311-.933-.3-1.086l-2.092-.523c-.616-.154-.987.22-.833.833l.523,2.092c.154.616.64.749,1.086.3l.4-.4Zm20.1-5.41a12.012,12.012,0,0,0-8.5-14.692l-.3,1.105a10.868,10.868,0,0,1,7.69,13.291l-.553-.148c-.61-.163-.963.2-.789.805l.593,2.073a.63.63,0,0,0,1.138.3l1.55-1.5c.457-.441.329-.929-.281-1.092l-.554-.148ZM12.874,5.394A12.012,12.012,0,0,0,4.412,20.1l1.105-.3A10.868,10.868,0,0,1,13.17,6.5l.147.547c.163.61.652.735,1.092.281l1.5-1.55a.63.63,0,0,0-.3-1.138L13.53,4.045c-.611-.175-.969.179-.805.789l.15.56Z"
                      transform="translate(-4 -4)"
                      fill="#bfbfbf"
                      fill-rule="evenodd"
                    />
                  </g>
                </g>
              </svg> */}
            </i>
          </span>
        </>
      ) : channelArray?.includes('email') || channelArray?.includes('emailattach') ? (
        <>
          <span className='channel-file email-icon'><i className="ds-icon email-icon">
            <svg
              id="noun-email-1002247"
              xmlns="http://www.w3.org/2000/svg"
              // width="24.602"
              // height="25"
              viewBox="0 0 24.602 25"
              width="16.731"
              height="20"
              style={{ marginTop: "4px" }}
            >
              <path
                id="Path_19"
                data-name="Path 19"
                d="M6.359,28.25H26.243A2.361,2.361,0,0,0,28.6,25.889V13.262a.669.669,0,0,0-.238-.511L25.072,9.97V5.122A1.872,1.872,0,0,0,23.2,3.25H9.533A1.872,1.872,0,0,0,7.661,5.122V9.868L4.238,12.751A.669.669,0,0,0,4,13.262V25.889A2.361,2.361,0,0,0,6.359,28.25ZM26.24,26.913H6.359a1.024,1.024,0,0,1-1.021-1.024V14.537l7.621,5.391-5.41,4.139a.669.669,0,1,0,.8,1.07l5.752-4.4,1.872,1.337a.669.669,0,0,0,.773,0l1.872-1.337,5.755,4.394a.669.669,0,0,0,.8-1.07l-5.4-4.131,7.487-5.295V25.891a1.024,1.024,0,0,1-1.021,1.021Zm.65-13.654-1.818,1.286V11.719ZM9.533,4.59H23.2a.535.535,0,0,1,.535.535V15.484L16.368,20.7,9,15.484V5.122A.535.535,0,0,1,9.533,4.59ZM7.661,14.545,5.768,13.208l1.893-1.6Zm8.64,2.722h.171a.669.669,0,0,0,0-1.337H16.3a4.262,4.262,0,1,1,4.262-4.262V12.81a.746.746,0,0,1-1.489,0V11.668A2.781,2.781,0,1,0,18,13.842a2.08,2.08,0,0,0,3.9-1.032V11.668a5.6,5.6,0,1,0-5.6,5.6Zm0-4.164a1.436,1.436,0,1,1,1.436-1.436A1.436,1.436,0,0,1,16.3,13.1Z"
                transform="translate(-4 -3.25)"
                fill="#bfbfbf"
              />
            </svg>
          </i></span>
        </>
      ) : (
        <>
          <span className='channel-file doc-icon'><i className="ds-icon doc-icon">
            <svg
              id="noun-document-5189726"
              xmlns="http://www.w3.org/2000/svg"
              // width="20"
              // height="25.603"
              viewBox="0 0 20 25.603"
              width="16.731"
              height="20"
              style={{ marginTop: "4px" }}
            >
              <path
                id="Path_5"
                data-name="Path 5"
                d="M32.716,8.471,26.923,2.679a.609.609,0,0,0-.431-.179H14.859a1.966,1.966,0,0,0-1.964,1.964V26.138A1.966,1.966,0,0,0,14.859,28.1H30.93a1.966,1.966,0,0,0,1.964-1.964V8.9A.609.609,0,0,0,32.716,8.471ZM27.1,4.581l3.711,3.711H27.847a.746.746,0,0,1-.745-.745V4.581Zm4.573,21.557a.746.746,0,0,1-.745.745H14.859a.746.746,0,0,1-.745-.745V4.464a.746.746,0,0,1,.745-.745H25.883V7.547a1.966,1.966,0,0,0,1.964,1.964h3.828Z"
                transform="translate(-12.895 -2.5)"
                fill="#bfbfbf"
              />
              <path
                id="Path_6"
                data-name="Path 6"
                d="M26.537,24.269h6.09a.58.58,0,1,0,0-1.16h-6.09a.58.58,0,1,0,0,1.16Z"
                transform="translate(-22.332 -17.541)"
                fill="#bfbfbf"
              />
              <path
                id="Path_7"
                data-name="Path 7"
                d="M25.957,40.109a.6.6,0,0,0,.626.58H38.631a.582.582,0,1,0,0-1.16H26.582A.6.6,0,0,0,25.957,40.109Z"
                transform="translate(-22.607 -29.525)"
                fill="#bfbfbf"
              />
              <path
                id="Path_8"
                data-name="Path 8"
                d="M38.631,55.948H26.582a.582.582,0,1,0,0,1.16H38.631a.582.582,0,1,0,0-1.16Z"
                transform="translate(-22.607 -41.509)"
                fill="#bfbfbf"
              />
              <path
                id="Path_9"
                data-name="Path 9"
                d="M38.631,72.368H26.582a.582.582,0,1,0,0,1.16H38.631a.582.582,0,1,0,0-1.16Z"
                transform="translate(-22.607 -53.493)"
                fill="#bfbfbf"
              />
            </svg>
          </i></span>
        </>
      )
    );
  }

  const addJobInWatchList = (rowData) => {
    let param = {
      clientId: clientId,
      userId: userId,
      jobId: rowData.jobNo,
      status: rowData?.isWatchList ? 0 : 1
    };
    dispatch(addJobsInWatchList(param));
    const params = {
      clientId: clientId,
      userId: userId,
      type: currentTab,
      channelType: selectedChannel.deliveryChannelId,
      filterView: checkedView ? 1 : 0,
      fromDate: fromDate ? moment(fromDate).format("YYYY-MM-DD") : '',
      toDate: toDate ? moment(toDate).format("YYYY-MM-DD") : '',
    }

    if (currentTab === jobConstants.TABS.LIVE) {
      params.pageNum = page;
      params.pageSize = size;
      dispatch(fetchJobs(params));
    } else if (currentTab === jobConstants.TABS.WATCHLIST) {
      params.jobNos = watchList.filter(item => item != rowData.jobNo).join();
      params.pageNum = watchListPage;
      params.pageSize = watchListSize;
      dispatch(fetchWatchListJobs(params));
    } else if (currentTab === jobConstants.TABS.ERROR) {
      params.pageNum = errorListPage;
      params.pageSize = errorListSize;
      dispatch(fetchErrorListJobs(params));
    } else {
      params.pageNum = favouriteListPage;
      params.pageSize = favouriteListSize;
      params.type = '';
      params.favJobs = favJobNames;
      dispatch(fetchFavouriteFilterJobs(params));
    }
  }

  // for watch Star icon
  const watchStar = (rowData) => {
    if (rowData.isWatchList) {
      return (
        <a onClick={() => addJobInWatchList(rowData)}><span className='watch-star'><i className="pi pi-star-fill"></i></span></a>
      );
    } else {
      return (
        <a onClick={() => addJobInWatchList(rowData)}><span className='watch-star'><i className="pi pi-star"></i></span></a>
      );
    }
  }

  const receivedDateBody = (rowData) => {
    return (
      <span>{moment(rowData.receivedDate).format("DD MMM YYYY-HH:mm")}</span>
    );

    // let parentDateReceived = parentJobList.filter((e) => {
    //   return e.jobIdentifier === rowData.jobIdentifier
    // });
    // return (
    //   <span>{moment(parentDateReceived[0]?.receivedDate).format("DD MMM YYYY-HH:mm")}</span>
    // );
  }

  const completeDateBody = (rowData) => {
    return (
      <span>{rowData.completeDate != '1900-01-01T00:00:00' ? moment(rowData.completeDate).format("DD MMM YYYY-HH:mm") : ''}</span>
    );
    // let parentDateCompleted = parentJobList.filter((e) => {
    //   return e.jobIdentifier === rowData.jobIdentifier
    // });
    // return (
    //   <span>{rowData.status == 'Complete' ? moment(parentDateCompleted[0]?.completeDate).format("DD MMM YYYY-HH:mm") : ''}</span>
    // );
  }

  // for coloured right group arrow
  const childJobstatusArrows = (rowData) => {
    const colorMap = {
      undefined: 'grey',
      Pass: 'green',
      Live: 'orange',
      Error: 'red',
    };

    const statusStage = {
      R: colorMap.Default,
      P: colorMap.Default,
      C: colorMap.Default,
    };

    const generateListItem = (code, currentStatus) => {
      const list = [];
      const statusObj = { ...statusStage }
      if (currentStatus === "RC" || currentStatus === "RI") {
        statusObj.R = code;
      } else if (currentStatus === "PF" || currentStatus === "PT" || currentStatus === "PP") {
        statusObj.R = "Pass";
        statusObj.P = code;
      } else {
        statusObj.R = "Pass";
        statusObj.P = "Pass";
        statusObj.C = code;
      }

      for (const e in statusObj) {
        // list.push(<li className={`arrow-right-${colorMap[statusObj[e]]}`}>{e}</li>)
        list.push(<li className={`arrow-right-${colorMap[statusObj[e]]}`}>{(currentLanguage === "FR" && e == "P") ? "T" : e}</li>)
      }
      return list;
    };

    return (
      <ul className='job-status-badge-block'>
        {generateListItem(rowData.code, rowData.newJobStatus)}
      </ul>
    );
  }

  const jobStatusArrows = (rowData) => {
    console.log(currentLanguage, "<<>>>")
    const colorMap = {
      undefined: 'grey',
      Pass: 'green',
      Live: 'orange',
      Error: 'red',
    };

    const statusStage = {
      R: colorMap.Default,
      P: colorMap.Default,
      C: colorMap.Default,
    };

    const generateListItem = (code, currentStatus) => {
      const list = [];
      const statusObj = { ...statusStage }
      if (currentStatus === "RC" || currentStatus === "RI") {
        statusObj.R = code;
      } else if (currentStatus === "PF" || currentStatus === "PT" || currentStatus === "PP") {
        statusObj.R = "Pass";
        statusObj.P = code;
      } else {
        statusObj.R = "Pass";
        statusObj.P = "Pass";
        statusObj.C = code;
      }

      for (const e in statusObj) {
        // list.push(<li className={`arrow-right-${colorMap[statusObj[e]]}`}>{e}</li>)
        list.push(<li className={`arrow-right-${colorMap[statusObj[e]]}`}>{(currentLanguage === "FR" && e == "P") ? "T" : e}</li>)
      }
      return list;
    };

    return (
      <ul className='job-status-badge-block'>
        {generateListItem(rowData.code, rowData.newJobStatus)}
      </ul>
    );
  };


  // for action icons
  const actionIcons = () => {
    return (
      <ul className='action-btn-block'>
        <li title={jobConstants.JOBLISTACTION.DEFAULT}><i className="pi ds-pause-icon"></i></li>
        <li title={appLanguage["datatable.label.tooltip.feature-licensed"]}><i className="pi ds-play-icon"></i></li>
        <li title={appLanguage["datatable.label.tooltip.feature-licensed"]}><i className="pi ds-ban-icon last-action-icon"></i></li>
      </ul>
    )
  }

  const allowExpansion = (e) => {
    return childJobList.length > 0;
  };

  const rowExpansionTemplate = () => {
    return (

      <div className="p-3 childJobHeader">
        <DataTable value={childJobList} dataKey="jobNo" rowClassName={rowClassChild}>
          <Column field="bullet" body={bulletPointChild} style={{ width: '5rem' }}></Column>
          <Column field="channel" header="Channel" body={channelFile} style={{}}></Column>
          <Column field="jobNo" body={" "} style={{ width: '5rem' }}>&nbsp;</Column>
          <Column field="jobIdentifier" header="Job No." style={{ width: '14rem', paddingLeft: '10px' }}></Column>
          <Column field="jobName" header="Job Name" body={getJobDetailChild} style={{ width: '35rem', textAlign: 'left', paddingLeft: '10px' }}></Column>
          {/* <Column field="workFlow" header="Workflow" style={{ width: '5rem' }}></Column> */}
          <Column field="receivedDate" header="Received" body={receivedDateBody} style={{ width: '25rem', textAlign: 'center' }}></Column>
          <Column field="slaStatus" header="Job Status" body={childJobstatusArrows} style={{ width: '15rem', textAlign: 'center' }}></Column>
          <Column field="" header="Watch" style={{ width: '5rem' }} ></Column>
          <Column key="completeDate" field="completeDate" header="Completed" body={completeDateBody} style={{ width: '25rem', textAlign: 'center' }}></Column>
          <Column field="status" header="Status" style={{ width: '10rem', textAlign: 'center' }}></Column>
          <Column field="action" header="Action" body={actionIcons} style={{ width: '10rem', textAlign: 'center' }}></Column>
        </DataTable>
      </div>
    );
  };

  useEffect(() => {
    const jobData = jobDetails[currentTabJobNo];
    let statusWidget = []
    let widgetMonth = []
    if (jobData) {
      for (const obj of jobData?.statusWidget) {
        // let monthName = obj?.monthName?.split('-')[0].charAt(0).toUpperCase() + obj?.monthName?.split('-')[0].slice(1);
        let monthName = obj?.monthName?.split('-')[0].charAt(0).toUpperCase();
        statusWidget.push(obj?.countJobs);
        widgetMonth.push(monthName);
      }
      const documentStyle = getComputedStyle(document.documentElement);
      const textColor = documentStyle.getPropertyValue('--text-color');
      const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
      const surfaceBorder = documentStyle.getPropertyValue('--surface-border');
      const data = {
        labels: widgetMonth,
        datasets: [
          {
            label: '',
            data: statusWidget,
            backgroundColor: ['#a39e9e', '#ed112a'],
            borderColor: ['#a39e9e', '#ed112a'],
            borderWidth: 1
          }
        ]
      };
      const options = {
        maintainAspectRatio: false,
        aspectRatio: 0.8,
        plugins: {
          tooltips: {
            mode: 'index',
            intersect: false
          },
          legend: {
            display: false   // 🔥 removes the gray box under the title
          },
          // legend: {
          //   labels: {
          //     color: textColor
          //   }
          // }
        },
        scales: {
          x: {
            stacked: true,
            ticks: {
              color: textColorSecondary
            },
            grid: {
              display: false,
              drawBorder: false,
              color: surfaceBorder
            }
          },
          y: {
            stacked: true,
            ticks: {
              color: textColorSecondary
            },
            grid: {
              drawBorder: false,
              color: surfaceBorder
            }
          }
        }
      };
      const newTabsArray = [...dynamicTabs];
      const newDynamicTabs = {
        jobNo: jobData.jobNo,
        // header: jobData.parentJobId,
        header: jobData?.executionWindow?.recordTypeReturn === 0 ? jobData?.executionWindow?.parentJobId : jobData?.executionWindow?.childJobId,
        content: getDynamicTabsHtml(jobData, data, options),
        closable: true,
        jobDeliveryChannelId: jobDeliveryChannelId
      };
      // const tabExist = newTabsArray.find(obj => obj.jobNo === jobData.jobNo && obj.jobDeliveryChannelId === jobData?.executionWindow?.DeliverychannelId);
      // if (!tabExist) {
      //   addDynamicTab(newDynamicTabs);
      //   setActiveTab(newTabsArray.length);
      // }
      addDynamicTab(newDynamicTabs);
      setActiveTab(newTabsArray.length);
    }
  }, [jobDetails]);


  const getJobDetails = (rowData, type) => {
    const channelArray = rowData?.channelType?.split(',');
    // const params = { "clientId": clientId, "userId": userId, "jobIdentifier": rowData.jobIdentifier, "deliveryChannelid": rowData.deliveryChannelId, "recordType": channelArray.length > 1 ? 0 : 1 };
    const params = { "clientId": clientId, "userId": userId, "jobIdentifier": rowData.jobIdentifier, "parentJobIdentifier": type === 1 ? rowData.parentjobidentifier : rowData.jobIdentifier, "deliveryChannelid": rowData.deliveryChannelId, "recordType": type };
    dispatch(fetchJobDetails(params));
    dispatch(setCurrentTabJobNo(rowData.jobIdentifier));
    dispatch(setJobDeliveryChannelId(rowData.deliveryChannelId));
  }

  const getJobDetailParent = (rowData) => {
    return (
      <span style={{ cursor: 'pointer' }} onClick={(e) => getJobDetails(rowData, 0)}>{rowData.jobName}</span>
    );
  }

  const getJobDetailChild = (rowData) => {
    return (
      <span style={{ cursor: 'pointer' }} onClick={(e) => getJobDetails(rowData, 1)}>{rowData.jobName}</span>
    );
  }

  const addDeleteIcon = (indexToRemove) => {
    return (
      <i className="pi pi-times" onClick={() => removeDynamicTab(indexToRemove)}></i>
    )
  };

  const addDynamicTab = (newData) => {
    setDynamicTabs(prevData => [...prevData, newData]);
  };

  const removeDynamicTab = (indexToRemove) => {
    const filteredArr = dynamicTabs.filter((_, index) => index !== indexToRemove);
    setDynamicTabs(filteredArr);
    setTimeout(function () {
      let activeIndex = 0;
      if (filteredArr.length > 1) {
        if (activeTab > filteredArr.length - 1) {
          activeIndex = filteredArr.length - 1;
        } else {
          activeIndex = activeTab + 1;
        }
      }
      setActiveTab(activeIndex);
    }, 100);
  };

  const formatTime = (totalSeconds) => {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return `${hours}h ${minutes}m ${seconds}s`;
  }

  const getDynamicTabsHtml = (currentJobDetail, chartData, chartOptions) => {
    console.log(currentJobDetail, "currentJobDetail")
    return (
      <>
        <div className="table-controls-wrap mnstmt-wrap"></div>
        <div className="three-col-wrap">
          <div className="card col-left">
            <div className="card-inner-wrap">
              <Card title={appLanguage["childjob.label.processing-overview"]}>

                <p>
                  <label>{appLanguage["childjob.label.filename"]}:</label>
                  <span title={currentJobDetail.executionWindow?.fileName}>{currentJobDetail.executionWindow?.fileName.length > 30 ? currentJobDetail.executionWindow?.fileName.substring(0, 30) + "..." : currentJobDetail.executionWindow?.fileName}</span>
                </p>

                {currentJobDetail.executionWindow?.recordTypeReturn === 0 && (
                  <>
                    <p>
                      <label>{appLanguage["childjob.label.totalRecords"]}:</label>
                      <span>{currentJobDetail.executionWindow?.totalItems}</span>
                    </p>
                  </>
                )}

                {currentJobDetail.executionWindow?.recordTypeReturn === 1 && (
                  <>
                    <p>
                      <label>{appLanguage["childjob.label.parent-filename"]}:</label>
                      <span title={currentJobDetail.executionWindow?.parentFileName}>{currentJobDetail.executionWindow?.parentFileName.length > 30 ? currentJobDetail.executionWindow?.parentFileName.substring(0, 30) + "..." : currentJobDetail.executionWindow?.parentFileName}</span>
                    </p>
                  </>
                )}

                <p>
                  <label>{appLanguage["childjob.label.local-job-id"]}:</label>
                  <span>{currentJobDetail.executionWindow?.localJobID}</span>
                </p>
                <p>
                  <label>{appLanguage["childjob.label.execution-type"]}:</label>
                  <span>{currentJobDetail.executionWindow?.executionType}</span>
                </p>
                <p>
                  <label>{appLanguage["details-childjob.label.delivery-channel"]}:</label>
                  <span>{currentJobDetail.executionWindow?.commsType}</span>
                </p>
                <p>
                  <label>{appLanguage["childjob.label.received"]}:</label>
                  <span>{currentJobDetail.executionWindow?.received ? moment(currentJobDetail.executionWindow?.received).format("DD MMM YYYY-HH:mm") : "/"}</span>
                </p>
                <p>
                  <label>{appLanguage["childjob.label.processed"]}:</label>
                  <span>{currentJobDetail.executionWindow?.processed ? moment(currentJobDetail.executionWindow?.processed).format("DD MMM YYYY-HH:mm") : "/"}</span>
                </p>
                <p>
                  <label>{appLanguage["childjob.label.completionDeadline"]}:</label>
                  <span>{currentJobDetail.executionWindow?.completionDeadline ? moment(currentJobDetail.executionWindow?.completionDeadline).format("DD MMM YYYY-HH:mm") : "/"}</span>
                </p>
                <p>
                  <label>{appLanguage["childjob.label.elapsed-time"]}:</label>
                  <span>{formatTime(currentJobDetail.executionWindow?.duration)}</span>
                </p>

                {currentJobDetail.executionWindow?.recordTypeReturn === 1 && currentJobDetail.executionWindow?.commsType != 'email' && currentJobDetail.executionWindow?.commsType != 'emailattach' && currentJobDetail.executionWindow?.commsType != 'sms' && (
                  <>
                    <p>
                      <label>{appLanguage["childjob.label.mailpiece-count"]}:</label>
                      <span>{currentJobDetail.executionWindow?.mailPieceCount}</span>
                    </p>
                    <p>
                      <label>{appLanguage["childjob.label.outer"]}:</label>
                      <span>{currentJobDetail.executionWindow?.outers}</span>
                    </p>
                    <p>
                      <label>{appLanguage["childjob.label.sheet-count"]}:</label>
                      <span>{currentJobDetail.executionWindow?.sheetCount}</span>
                    </p>
                    <p>
                      <label>{appLanguage["childjob.label.page-count"]}:</label>
                      <span>{currentJobDetail.executionWindow?.pageCount}</span>
                    </p>

                  </>
                )}

                {(currentJobDetail.executionWindow?.recordTypeReturn === 0 || currentJobDetail.executionWindow?.recordTypeReturn === 1) && currentJobDetail.executionWindow?.commsType != 'email' && currentJobDetail.executionWindow?.commsType != 'emailattach' && currentJobDetail.executionWindow?.commsType != 'sms' && (
                  <p>
                    <label>{appLanguage["childjob.label.completed"]}:</label>
                    <span>{currentJobDetail.executionWindow?.completed ? moment(currentJobDetail.executionWindow?.completed).format("DD MMM YYYY-HH:mm") : "/"}</span>
                  </p>
                )}

                {currentJobDetail.executionWindow?.recordTypeReturn === 1 && currentJobDetail.executionWindow?.commsType == 'email' && (
                  <p>
                    <label>{appLanguage["childjob.label.email-count"]}:</label>
                    <span>{currentJobDetail.executionWindow?.emailCount}</span>
                  </p>
                )}

                {currentJobDetail.executionWindow?.recordTypeReturn === 1 && currentJobDetail.executionWindow?.commsType == 'sms' && (
                  <p>
                    <label>{appLanguage["childjob.label.sms-count"]}:</label>
                    <span>{currentJobDetail.executionWindow?.smsCount}</span>
                  </p>
                )}

                {(currentJobDetail.executionWindow?.recordTypeReturn === 0 || currentJobDetail.executionWindow?.recordTypeReturn === 1) && (currentJobDetail.executionWindow?.commsType == 'email' || currentJobDetail.executionWindow?.commsType == 'emailattach' || currentJobDetail.executionWindow?.commsType == 'sms') && (
                  <p>
                    <label>{appLanguage["childjob.label.distributed"]}:</label>
                    <span>{currentJobDetail.executionWindow?.distributed ? moment(currentJobDetail.executionWindow?.distributed).format("DD MMM YYYY-HH:mm") : "/"}</span>
                  </p>
                )}

              </Card>
            </div>
          </div>

          <div className="card col-mid">
            <div className="card-inner-wrap">
              <Card title="">
                <p>
                  <label>{appLanguage["childjob.label.name"]}:</label>
                  <span>{currentJobDetail.metaWindow?.name ? currentJobDetail.metaWindow?.name : "/"}</span>
                </p>
                <p>
                  <label>{appLanguage["childjob.label.description"]}:</label>
                  <span>{currentJobDetail.metaWindow?.description ? currentJobDetail.metaWindow?.description : "/"}</span>
                </p>
                <p>
                  <label>{appLanguage["childjob.label.owner"]}:</label>
                  <span>{currentJobDetail.metaWindow?.owner ? currentJobDetail.metaWindow?.owner : "/"}</span>
                </p>
                {(currentJobDetail.executionWindow?.recordTypeReturn === 0 || currentJobDetail.executionWindow?.recordTypeReturn === 1) && (currentJobDetail.executionWindow?.commsType == 'email' || currentJobDetail.executionWindow?.commsType == 'emailattach' || currentJobDetail.executionWindow?.commsType == 'sms') && (
                  <p>
                    <label>{appLanguage["childjob.label.type"]}:</label>
                    <span>{currentJobDetail.metaWindow?.type ? currentJobDetail.metaWindow?.type : "/"}</span>
                  </p>
                )}
                {(currentJobDetail.executionWindow?.recordTypeReturn === 0 || currentJobDetail.executionWindow?.recordTypeReturn === 1) && currentJobDetail.executionWindow?.commsType != 'email' && currentJobDetail.executionWindow?.commsType != 'emailattach' && currentJobDetail.executionWindow?.commsType != 'sms' && (
                  <>
                    <p>
                      <label>{appLanguage["childjob.label.stocks"]}:</label>
                      <span>{currentJobDetail.metaWindow?.stocks}</span>
                    </p>
                    <p>
                      <label>{appLanguage["childjob.label.enclosure"]}:</label>
                      <span>{currentJobDetail.metaWindow?.enclosure ? currentJobDetail.metaWindow?.enclosure : "/"}</span>
                    </p>
                    <p>
                      <label>{appLanguage["childjob.label.inserts"]}:</label>
                      <span>{currentJobDetail.metaWindow?.inserts}</span>
                    </p>
                  </>
                )}
                <p>
                  <label>{appLanguage["childjob.label.color-profile"]}:</label>
                  <span>{currentJobDetail.metaWindow?.colorProfile ? currentJobDetail.metaWindow?.colorProfile : "/"}</span>
                </p>
                <p>
                  <label>{appLanguage["childjob.label.last-completed"]}:</label>
                  <span>{currentJobDetail.metaWindow?.lastCompleted ? moment(currentJobDetail.metaWindow?.lastCompleted).format("DD MMM YYYY-HH:mm") : "/"}</span>
                </p>
              </Card>
            </div>
          </div>

          <div className="card col-right">
            <Card style={{ textAlign: 'center' }} title={appLanguage["childjob.label.monthly-volumn"]}>
              <Chart type="bar" data={chartData} options={chartOptions} />
            </Card>
          </div>
        </div>
        {/* <hr className='footer-border' /> */}
      </>
    );
  }

  useEffect(() => {
    if (jobListExist === false) {
      const newDynamicTabs = {
        // header: appLanguage["datatable.label.joblist"],
        content: getDefaultTabData(),
        closable: false,
      };
      dispatch(setJobListExist(true));
      addDynamicTab(newDynamicTabs);
    } else {
      updateItemAtIndex(0, 'content', getDefaultTabData());
    }
  }, [
    userFavouritesJobList,
    parentJobList,
    expandedRows,
    childJobList,
    fromDate,
    setPage,
    setSize,
    setBasicFirst,
    setBasicRows,
    setWatchListPage,
    setWatchListSize,
    setWatchListFirst,
    setWatchListRows,
    setErrorListPage,
    setErrorListSize,
    setErrorListFirst,
    setErrorListRows,
    setFavouriteListPage,
    setFavouriteListSize,
    setFavouriteListFirst,
    setFavouriteListRows,
    jobRecordsWidgit,
    appLanguage,
    currentLanguage,
  ]);

  // Force re-render when language changes
  useEffect(() => {
    if (dynamicTabs.length > 0) {
      updateItemAtIndex(0, 'content', getDefaultTabData());
    }
  }, [currentLanguage]);

  const updateItemAtIndex = (index, attributName, attributeValue) => {
    const newArray = [...dynamicTabs];
    newArray[index] = { ...newArray[index], [attributName]: attributeValue };
    if (index === 0) {
      newArray[index] = { ...newArray[index], ["header"]: appLanguage["datatable.label.joblist"] };
      newArray[index] = { ...newArray[index], ["closable"]: false };
    }
    setDynamicTabs(newArray);
  };

  /* For Paginator Template Start */
  const footer = (
    <React.Fragment>
      <Paginator
        className="pagination-wrap"
        first={currentTab == 0 ? basicFirst : currentTab == 1 ? watchListFirst : currentTab == 2 ? errorListFirst : favouriteListFirst}
        rows={currentTab == 0 ? basicRows : currentTab == 1 ? watchListRows : currentTab == 2 ? errorListRows : favouriteListRows}
        totalRecords={currentTab == 0 ? totalRecords : currentTab == 1 ? watchListTotalRecords : currentTab == 2 ? errorListTotalRecords : favouriteListTotalRecords}
        onPageChange={(e) => onBasicPageChange(e)}
        rowsPerPageOptions={rowsPerPageOptions}
        template="CurrentPageReport PrevPageLink NextPageLink RowsPerPageDropdown"
        // currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
        currentPageReportTemplate={`${appLanguage["datatable.label.pagination.showing"]} {first} ${appLanguage["datatable.label.pagination.to"]} {last} of {totalRecords}`}
      ></Paginator>
    </React.Fragment>
  );

  const onBasicPageChange = (e) => {
    const params = {
      clientId: clientId,
      userId: userId,
      type: currentTab,
      channelType: selectedChannel.deliveryChannelId,
      filterView: checkedView ? 1 : 0,
      fromDate: fromDate ? moment(fromDate).format("YYYY-MM-DD") : '',
      toDate: toDate ? moment(toDate).format("YYYY-MM-DD") : '',
    }
    if (currentTab === jobConstants.TABS.LIVE) {
      params.pageNum = e.page + 1;
      params.pageSize = e.rows;
      dispatch(fetchJobs(params));
      dispatch(setBasicFirst(e.first));
      dispatch(setBasicRows(e.rows));
      dispatch(setPage(e.page + 1));
      dispatch(setSize(e.rows));
    } else if (currentTab === jobConstants.TABS.WATCHLIST) {
      params.pageNum = e.page + 1;
      params.pageSize = e.rows;
      params.jobNos = watchList.join();
      dispatch(fetchWatchListJobs(params));
      dispatch(setWatchListFirst(e.first));
      dispatch(setWatchListRows(e.rows));
      dispatch(setWatchListPage(e.page + 1));
      dispatch(setWatchListSize(e.rows));
    } else if (currentTab === jobConstants.TABS.ERROR) {
      params.pageNum = e.page + 1;
      params.pageSize = e.rows;
      dispatch(fetchErrorListJobs(params));
      dispatch(setErrorListFirst(e.first));
      dispatch(setErrorListRows(e.rows));
      dispatch(setErrorListPage(e.page + 1));
      dispatch(setErrorListSize(e.rows));
    } else {
      params.pageNum = e.page + 1;
      params.pageSize = e.rows;
      params.type = '';
      params.favJobs = favJobNames;
      dispatch(fetchFavouriteFilterJobs(params));
      dispatch(setFavouriteListFirst(e.first));
      dispatch(setFavouriteListRows(e.rows));
      dispatch(setFavouriteListPage(e.page + 1));
      dispatch(setFavouriteListSize(e.rows));
    }
  }
  /* For Paginator Template End */

  const getDefaultTabData = () => {
    return (
      <>
        <div className="table-controls-wrap job-list-table-controls-wrap">
          <ul>
            <li key="channel-filter" className="channel-filter">
              <label htmlFor="">{appLanguage["datatable.label.channel-filter"]}</label>
              <Dropdown value={selectedChannel} onChange={(e) => channelByFilteredJob(e)} options={deliveryChannelFilterList} optionLabel="deliveryChannel" placeholder={appLanguage["datatable.label.select-channel-dd"]} className="w-full md:w-14rem channel-dropdown" />
            </li>
            {/* <li key="simview-toggle" className="simview-toggle">
              <label htmlFor="">Adv/Sim View</label>
              <InputSwitch checked={checkedView} onChange={(el) => filterByView(el)} />
            </li> */}
            <li key="from-date" className="from-date">
              <label htmlFor="">{appLanguage["datatable.label.received-between"]}</label>
              <Calendar value={fromDate} onChange={(e) => onChangeFromDate(e)} placeholder="dd-mm-yyyy" dateFormat="dd-mm-yy" showIcon />
              <label htmlFor="">-</label>
              <Calendar value={toDate} onChange={(e) => onChangeToDate(e)} minDate={fromDate} placeholder="dd-mm-yyyy" dateFormat="dd-mm-yy" showIcon />
            </li>
          </ul>
        </div>

        <DataTable key={currentLanguage} value={parentJobList} expandedRows={expandedRows} onRowToggle={(e) => dispatch(setExpandedRows(e.data))} rowExpansionTemplate={rowExpansionTemplate} dataKey="jobIdentifier" tableStyle={{ minWidth: '50rem' }} footer={footer} rowClassName={rowClass} scrollable scrollHeight='385px' className='fixPagination'>
          <Column key="bullet" field="bullet" body={bulletPoint} style={{ width: '5rem' }}></Column>
          <Column key="channel" field="channel" header={appLanguage["datatable.label.channel"]} body={channelFile} style={{}}></Column>
          <Column key="expander" field="expander" expander={allowExpansion} style={{ width: '5rem' }} body={expenderRow} />
          <Column key="jobIdentifier" field="jobIdentifier" header={appLanguage["datatable.label.jobno"]} style={{ width: '14rem' }}></Column>
          <Column key="jobName" field="jobName" header={appLanguage["datatable.label.jobname"]} body={getJobDetailParent} style={{ width: '35rem', textAlign: 'left' }}></Column>
          {/* <Column key="jobName" field="jobName" header={appLanguage["datatable.label.jobname"]} style={{ width: '35rem', textAlign: 'left' }}></Column> */}
          {/* <Column key="workFlow" field="workFlow" header="Workflow" style={{ width: '5rem' }}></Column> */}
          <Column key="receivedDate" field="receivedDate" header={appLanguage["datatable.label.Received"]} body={receivedDateBody} style={{ width: '25rem' }}></Column>
          <Column key="slaStatus" field="slaStatus" header={appLanguage["datatable.label.jobstatus"]} body={jobStatusArrows} style={{ width: '15rem' }}></Column>
          <Column key="isWatchList" field="isWatchList" header={appLanguage["datatable.label.watch"]} body={watchStar} style={{ width: '5rem' }}></Column>
          <Column key="completeDate" field="completeDate" header={appLanguage["datatable.label.completed"]} body={completeDateBody} style={{ width: '25rem' }}></Column>
          <Column key="status" field="status" header={appLanguage["datatable.label.status"]} style={{ width: '10rem' }}></Column>
          <Column key="action" field="action" header={appLanguage["datatable.label.action"]} body={actionIcons} style={{ width: '10rem' }}></Column>
        </DataTable>
      </>
    );
  }

  const rowClass = (rowData) => {
    return {
      'job-expended-row': rowData.jobIdentifier == Object.keys(expandedRows).join()
    }
  }
  const rowClassChild = (rowData) => {
    return {
      'job-expended-row-child': true
    }
  }

  const expenderRow = (rowData, e) => {
    const parentJobNo = rowData.jobIdentifier;
    let params = {
      clientId: clientId,
      userId: userId,
      jobNo: parentJobNo,
      channelType: selectedChannel.deliveryChannelId,
      pageNum: 1,
      pageSize: 20
    };
    const hasChildren = rowData.recordCount > 0 ? true : false;
    const clickEvent = () => {
      if (!hasChildren) return;
      let _expandedRows = {};
      if (expandedRows) {
        if (expandedRows[`${rowData.jobIdentifier}`]) {
          const newDataObject = { ...expandedRows };
          delete newDataObject[`${rowData.jobIdentifier}`];
          dispatch(setExpandedRows(newDataObject));
        } else {
          dispatch(fetchChildJobs(params));
          _expandedRows[`${rowData.jobIdentifier}`] = true;
        }
      } else {
        dispatch(fetchChildJobs(params));
        _expandedRows[`${rowData.jobIdentifier}`] = true;
      }
      dispatch(setExpandedRows(_expandedRows));
    }
    return (
      <>
        {/* <a href='javascript:void(0)' onClick={clickEvent}><i className={'pi pi-' + (expandedRows && expandedRows[`${rowData.jobIdentifier}`] == true ? 'minus' : 'plus')}></i></a> */}
        <a
          href="javascript:void(0)"
          onClick={hasChildren ? clickEvent : undefined}
          title={hasChildren ? '' : 'No Child Available'}
          style={{ cursor: hasChildren ? 'pointer' : 'not-allowed', color: hasChildren ? 'inherit' : 'gray' }}
        >
          {hasChildren && (
            <i className={'pi pi-' + (expandedRows && expandedRows[`${rowData.jobIdentifier}`] === true ? 'minus' : 'plus')}></i>
          )}
        </a>
      </>
    )
  }

  const onChangeFromDate = (e) => {
    dispatch(setDefaultFilterStatus(false));
    dispatch(setToDate(''));
    setToDateEnabled(false);
    dispatch(setFromDate(e.value));
  }

  const onChangeToDate = (e) => {
    dispatch(setDefaultFilterStatus(false));
    dispatch(setToDate(e.value));
    let reportParams = {
      clientId: clientId,
      userId: userId,
      channelType: selectedChannel.deliveryChannelId,
      fromDate: fromDate ? moment(fromDate).format("YYYY-MM-DD") : '',
      toDate: e.value ? moment(e.value).format("YYYY-MM-DD") : '',
    };
    dispatch(fetchJobsRecordsWedgit(reportParams));

    const params = {
      clientId: clientId,
      userId: userId,
      type: currentTab,
      channelType: selectedChannel.deliveryChannelId,
      filterView: checkedView ? 1 : 0,
      fromDate: fromDate ? moment(fromDate).format("YYYY-MM-DD") : '',
      toDate: e.value ? moment(e.value).format("YYYY-MM-DD") : '',
    }
    if (currentTab === jobConstants.TABS.LIVE) {
      dispatch(setPage(1));
      dispatch(setBasicFirst(0));
      dispatch(setBasicRows(basicRows));
      params.pageNum = 1;
      params.pageSize = size;
      dispatch(fetchJobs(params));
    } else if (currentTab === jobConstants.TABS.WATCHLIST) {
      dispatch(setWatchListPage(1));
      dispatch(setWatchListFirst(0));
      dispatch(setWatchListRows(watchListRows));
      params.jobNos = watchList.join();
      params.pageNum = 1;
      params.pageSize = watchListSize;
      dispatch(fetchWatchListJobs(params));
    } else if (currentTab === jobConstants.TABS.ERROR) {
      dispatch(setErrorListPage(1));
      dispatch(setErrorListFirst(0));
      dispatch(setErrorListRows(errorListRows));
      params.pageNum = 1;
      params.pageSize = errorListSize;
      dispatch(fetchErrorListJobs(params));
    } else {
      dispatch(setFavouriteListPage(1));
      dispatch(setFavouriteListFirst(0));
      dispatch(setFavouriteListRows(favouriteListRows));
      params.pageNum = 1;
      params.pageSize = favouriteListSize;
      params.type = '';
      params.favJobs = favJobNames;
      dispatch(fetchFavouriteFilterJobs(params));
    }
  }

  const channelByFilteredJob = (e) => {
    dispatch(setSelectedChannel(e.value));
    const params = {
      clientId: clientId,
      userId: userId,
      type: currentTab,
      channelType: e.value.deliveryChannelId,
      filterView: checkedView ? 1 : 0,
      fromDate: fromDate ? moment(fromDate).format("YYYY-MM-DD") : '',
      toDate: toDate ? moment(toDate).format("YYYY-MM-DD") : '',
    }

    let reportParams = {
      clientId: clientId,
      userId: userId,
      channelType: e.value.deliveryChannelId,
      fromDate: fromDate ? moment(fromDate).format("YYYY-MM-DD") : '',
      toDate: toDate ? moment(toDate).format("YYYY-MM-DD") : '',
    };
    dispatch(fetchJobsRecordsWedgit(reportParams));

    if (currentTab === jobConstants.TABS.LIVE) {
      dispatch(setPage(1));
      dispatch(setBasicFirst(0));
      dispatch(setBasicRows(basicRows));
      params.pageNum = 1;
      params.pageSize = size;
      dispatch(fetchJobs(params));
    } else if (currentTab === jobConstants.TABS.WATCHLIST) {
      dispatch(setWatchListPage(1));
      dispatch(setWatchListFirst(0));
      dispatch(setWatchListRows(watchListRows));
      params.jobNos = watchList.join();
      params.pageNum = 1;
      params.pageSize = watchListSize;
      dispatch(fetchWatchListJobs(params));
    } else if (currentTab === jobConstants.TABS.ERROR) {
      dispatch(setErrorListPage(1));
      dispatch(setErrorListFirst(0));
      dispatch(setErrorListRows(errorListRows));
      params.pageNum = 1;
      params.pageSize = errorListSize;
      dispatch(fetchErrorListJobs(params));
    } else {
      dispatch(setFavouriteListPage(1));
      dispatch(setFavouriteListFirst(0));
      dispatch(setFavouriteListRows(favouriteListRows));
      params.pageNum = 1;
      params.pageSize = favouriteListSize;
      params.type = '';
      params.favJobs = favJobNames;
      dispatch(fetchFavouriteFilterJobs(params));
    }
  }

  const onTabViewChange = (event) => {
    setActiveTab(event.index);
  };

  const customHeaderTemplate = (options, tabName) => {
    return (
      <a style={{ cursor: 'pointer' }} onClick={options.onClick} id="pr_id_2_header_0" role="tab" className="p-tabview-nav-link" tabIndex="0" aria-controls="pr_id_2_content_0" data-pc-section="headeraction">
        <span class="p-tabview-title" data-pc-section="headertitle">
          {tabName}&nbsp;{options.index > 0 && addDeleteIcon(options.index)}
        </span>
      </a>
    );
  };

  return (
    <div className={"cards job-view-wrap" + (activeTab === 0 ? " default-job-view-wrap" : "")}>
      <div className="tab-wrap">
        <TabView activeIndex={activeTab} onTabChange={onTabViewChange}>
          {dynamicTabs && dynamicTabs.length > 0 && dynamicTabs.map((dynamicTab, dTIndex) => (
            <TabPanel
              key={dTIndex}
              header={dynamicTab.header + "==" + dTIndex}
              closable={false}
              headerTemplate={(e) => customHeaderTemplate(e, dynamicTab.header)}>
              {dynamicTab.content}
            </TabPanel>
          ))}
        </TabView>
      </div>
    </div>
  );
}
